import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/sales-rep/compound/units";
const apiToggleSaleStatus = API_BASE_URL_ENV() + "/crm/change-unit-status";
const apiToggleStatus = API_BASE_URL_ENV() + "/sales-rep/compound/toggle-activation/Unit";
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/sales-rep/compound/dropdown/Unit?status=1";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
    
    toggleSaleStatus(id) {
        return http.get(`${apiToggleSaleStatus}/${id}`);
    }

    toggleStatus(id) {
        return http.get(`${apiToggleStatus}/${id}`);
    }

    getDropDown = (id, sale_status) => {
        let query = null;
        if (id) {
            query= `&building_ids=${id}`;
        }  else if (sale_status) {
            query= `&sale_status=${sale_status}`;
        }
        if(query) return http.get(`${apiDropDownEndpoint}${query}`)
        else return http.get(apiDropDownEndpoint)
    }

    getDropDownCustom = (id) => {
        if (id) {
            return http.get(`${apiDropDownEndpoint}&compound_ids=${id}`)
        } else {
            return http.get(apiDropDownEndpoint)

        }
    }
}
